import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { BlockSectionLayoutProps } from '@ts-blocks/block-section-layout/interfaces'
import type { SectionInternalLinkProps } from '@ts-sections/section-internal-link/interfaces'

interface SectionInternalLinkHookOptions {
  section: () => SectionInternalLinkProps
}

interface SectionInternalLinkHookReturn {
  refBackgroundColor: ComputedRef<NonNullable<BlockSectionLayoutProps['backgroundColor']>>
}

export const useSectionInternalLink = (
  { section }: SectionInternalLinkHookOptions,
): SectionInternalLinkHookReturn => {
  const refBackgroundColor = computed<NonNullable<BlockSectionLayoutProps['backgroundColor']>>(() => (
    section().layout?.backgroundColor ?? 'canvas'
  ))

  return {
    refBackgroundColor,
  }
}
